module.exports = __webpack_public_path__ + "static/media/icon-trainingsraum.b1cb61c4.svg";